import * as React from 'react'
function SvgViewOff(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="currentColor" fillRule="evenodd">
				<path d="M33.2 15.2L16.8 31.6c1 .2 2.2.4 3.2.4 7.2 0 12.8-6.2 15.2-9.8 1-1.4 1-3.2 0-4.6-.4-.6-1.2-1.4-2-2.4zM32.6 4.6L27.2 10C25 8.8 22.6 8 20 8c-7.2 0-12.8 6.2-15.2 9.8-1 1.4-1 3.2 0 4.4 1 1.6 2.8 3.6 4.8 5.4l-5 5c-.8.8-.8 2 0 2.8.4.4.8.6 1.4.6.6 0 1-.2 1.4-.6l28-28c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0zm-18 18c-.4-.8-.6-1.6-.6-2.6 0-3.4 2.6-6 6-6 1 0 1.8.2 2.6.6l-8 8z" />
			</g>
		</svg>
	)
}
export default SvgViewOff
